<template>
  <div>
    <el-checkbox v-model="isChecked" @change="updated"></el-checkbox>
  </div>
</template>

<script>
export default {
  props: {
    checked: {
      default: false
    },
    onUpdate: {
      required: true
    },
    destinationId: {
      required: true
    }
  },
  data () {
    return {
      isChecked: null
    }
  },
  beforeMount() {
    this.isChecked = (this.checked == 1)
  },
  methods: {
    updated () {
      this.onUpdate({
        checked: this.isChecked,
        destination_id: this.destinationId
      })
    }
  }
}
</script>
